<button
	type="button"
	class="trigger"
	[class.is-open]="showDropdown()"
	aria-haspopup="dialog"
	[attr.aria-expanded]="showDropdown()"
	[attr.aria-label]="'Profielmenu van ' + begroetingsnaam()"
	(click)="openMenu()"
	#triggerHost
>
	<app-pasfoto size="size-2-5" [pasfotoKey]="afkorting()" />
</button>
